import { render } from "./MywalletDepositWebsite.vue?vue&type=template&id=dba55bd8&scoped=true"
import script from "./MywalletDepositWebsite.vue?vue&type=script&lang=js"
export * from "./MywalletDepositWebsite.vue?vue&type=script&lang=js"

import "./MywalletDepositWebsite.vue?vue&type=style&index=0&id=dba55bd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba55bd8"]])

export default __exports__